<template>
  <div>
    <div class="flex items-center mb-4">
      <img
        class="w-full md:hidden"
        src="../../assets/horizontal-tree.svg"
      >
      <img
        class="hidden md:block"
        src="../../assets/round-tree.svg"
      >
    </div>
    <BaseSection class="md:p-0">
      <BaseParagraph
        class="mb-4 md:max-w-sm"
        v-html="$t('KYC financial introduction')"
      />
    </BaseSection>
  </div>
</template>

<script>
import BaseSection from '../../components/BaseSection.vue';
import BaseParagraph from '../../components/BaseParagraph.vue';

export default {
  name: 'FinancialContent',
  components: {
    BaseSection,
    BaseParagraph,
  },
};
</script>
